const LEGACY_TOKEN_KEYS = [
  "authToken",
  "token",
  "auth_token",
  "access_token",
  "refresh_token",
  "access",
  "refresh",
];

export function legacyBearerAuthEnabled(currentWindow = window) {
  const hostname = String(currentWindow?.location?.hostname || "").toLowerCase();
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
  const localE2eBridge = (
    process.env.REACT_APP_E2E_ALLOW_LEGACY_AUTH_TOKENS === "1"
    && isLocal
  );
  return (
    localE2eBridge
    || (
      process.env.NODE_ENV !== "production"
      && process.env.REACT_APP_ALLOW_LEGACY_AUTH_TOKENS !== "0"
      && isLocal
    )
  );
}

export function clearLegacyAuthTokens(currentWindow = window) {
  for (const storage of [currentWindow?.localStorage, currentWindow?.sessionStorage]) {
    if (!storage) continue;
    for (const key of LEGACY_TOKEN_KEYS) {
      try {
        storage.removeItem(key);
      } catch (_error) {
        // Storage can be unavailable in privacy modes; cookie auth still works.
      }
    }
  }
}

export function readLegacyAuthToken(currentWindow = window) {
  if (!legacyBearerAuthEnabled(currentWindow)) {
    clearLegacyAuthTokens(currentWindow);
    return null;
  }

  const read = (storage, key) => {
    try {
      const raw = storage?.getItem(key);
      if (!raw) return null;
      return raw.startsWith("\"") && raw.endsWith("\"") ? JSON.parse(raw) : raw;
    } catch (_error) {
      return null;
    }
  };

  for (const storage of [currentWindow?.localStorage, currentWindow?.sessionStorage]) {
    for (const key of LEGACY_TOKEN_KEYS) {
      const token = read(storage, key);
      if (token) return token;
    }
  }
  return null;
}

export function storeLegacyAuthToken(token, currentWindow = window) {
  clearLegacyAuthTokens(currentWindow);
  if (!token || !legacyBearerAuthEnabled(currentWindow)) return;
  try {
    currentWindow.localStorage.setItem("authToken", token);
  } catch (_error) {
    // A blocked storage area simply disables the local compatibility bridge.
  }
}
